import React, { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";

const ProtectedRoute: React.FC = () => {
    const navigate = useNavigate();
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        // Check if the page was refreshed
        const wasRefreshed = sessionStorage.getItem("wasRefreshed");

        if (wasRefreshed === "true") {
            // If refreshed, clear the flag and redirect
            sessionStorage.removeItem("wasRefreshed");
           if (!isAuthenticated) {
               navigate("/", { replace: true });
              }
        } else {
            // First-time visit, set session storage flag
            sessionStorage.setItem("wasRefreshed", "true");
        }

        return () => {
            // Clear session flag on route change (so it persists only on refresh)
            sessionStorage.removeItem("wasRefreshed");
        };
    }, [navigate]);

    return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
